interface CookiePreferences {
  essential: boolean;
  analytics: boolean;
  marketing: boolean;
}

export function setCookie(name: string, value: string, days: number = 365) {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/;SameSite=Strict`;
}

export function getCookie(name: string): string | null {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function deleteCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Strict`;
}

export function handleCookiePreferences(preferences: CookiePreferences) {
  // Essential cookies are always enabled
  setCookie('essential_cookies', 'true');

  // Analytics cookies
  if (preferences.analytics) {
    setCookie('analytics_cookies', 'true');
    // Enable analytics tracking
    window.gtag?.('consent', 'update', {
      analytics_storage: 'granted'
    });
  } else {
    deleteCookie('analytics_cookies');
    // Disable analytics tracking
    window.gtag?.('consent', 'update', {
      analytics_storage: 'denied'
    });
  }

  // Marketing cookies
  if (preferences.marketing) {
    setCookie('marketing_cookies', 'true');
    // Enable marketing features
    window.gtag?.('consent', 'update', {
      ad_storage: 'granted'
    });
  } else {
    deleteCookie('marketing_cookies');
    // Disable marketing features
    window.gtag?.('consent', 'update', {
      ad_storage: 'denied'
    });
  }
}